import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../../commponents/layout/adminLayout";
import DocumentInformation, {
  type DocumentFieldConfig,
} from "../../commponents/document/DocumentInformation";
import DeliveryOrderItemTable from "../../commponents/deliveryOrder/DeliveryOrderItemTable";
import type { DeliveryOrderItemRow } from "../../commponents/deliveryOrder/DeliveryOrderItemTable";
import CustomerPicker from "../../commponents/document/CustomerPicker";


import {
  createDeliveryOrder,
  getdeliveryOrderStatus,
} from "../../api/deliveryOrderApi";

import type { CustomerOption } from "../../api/customerApi";
import type { status } from "../../commponents/StatusDropdown";
import StatusDropdown from "../../commponents/StatusDropdown";

import {
  type FieldErrors,
  type ItemsErrors,
  runFieldValidation,
  requiredText,
  positiveNumber,
  validateItems,
  withErrorClear,
  focusFirstError,
} from "../../helpers/validation";
import { showError, showSuccess } from "../../utils/ alert";
import { editStatusQuotation, getQuotationById } from "../../api/quotationApi";
import { getSales } from "../../api/salesApi";

interface SalesOption {
  id: number;
  name: string;
}

interface DeliveryOrderFormValue {
  bill_to: string;
  address: string;
  phone: string;
  delivery_order_no?: string;
  delivery_date: string;
  po_number: string;

  due_date: string;
  sales_id: number | null;
}

const inputClass =
  "w-full rounded-lg border border-gray-200 px-3 py-2 text-sm outline-none focus:border-blue-400";

export default function AddDeliveryOrder() {

  const { quotationId } = useParams();


  const navigate = useNavigate();

  const { delivery_order_id } = useParams();

  const [loading, setLoading] = useState(Boolean(delivery_order_id));

  const [billTo, setBillTo] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");

  const [poNumber, setPoNumber] = useState("");

  const [dueDate, setDueDate] = useState("");

  // Optional link to an existing customer record.
  const [customerQuery, setCustomerQuery] = useState("");
  const [customerIdRef, setCustomerIdRef] = useState<number | null>(null);

   const [items, setItems] = useState<DeliveryOrderItemRow[]>([]);

  const [checkedBy, setCheckedBy] = useState("");
  const [approvedBy, setApprovedBy] = useState("");
  const [receivedBy, setReceivedBy] = useState("");

  const [statusOptions, setStatusOptions] = useState<status[]>([]);
  const [deliveryOrderStatusId, setDeliveryOrderStatusId] = useState<number>(0);
  const [submitting, setSubmitting] = useState(false);

  // --- validation state -------------------------------------------------
  const [errors, setErrors] = useState<FieldErrors>({});
  const [itemsErrors, setItemsErrors] = useState<ItemsErrors>({});
  const [itemsGeneralError, setItemsGeneralError] = useState<string | undefined>();
  const [salesId, setSalesId] = useState<number | null>(null);
  
  const [salesOptions, setSalesOptions] = useState<SalesOption[]>([]);

  const handleCancel = () => navigate("/delivery_order");

    // Ambil daftar sales buat dropdown
    useEffect(() => {
      const fetchSales = async () => {
        try {
          const response = await getSales({
            page: 1,
            limit: 10,
          });
          setSalesOptions(response.data.salesList ?? []);
        } catch (error) {
          showError(
          "Failed",
          "Failed to Load data."
      );
        }
      };
  
      fetchSales();
    }, []);

  const handleSelectCustomer = (customer: CustomerOption) => {
    setCustomerIdRef(customer.id);
    setCustomerQuery(
      customer.companyName
        ? `${customer.customerName} (${customer.companyName})`
        : customer.customerName
    );
    setBillTo(customer.companyName ?? customer.customerName);
    setAddress(customer.address ?? "");
    setPhone(customer.phone ?? "");

  };

  const handleClearCustomer = () => {
    setCustomerIdRef(null);
    setCustomerQuery("");
  };

  const validate = () => {
    const fieldErrors = runFieldValidation<DeliveryOrderFormValue>(
      {
        bill_to: billTo,
        address,
        phone,
        sales_id: salesId,
        delivery_date: deliveryDate,
        po_number: poNumber,
   
        due_date: dueDate,
      },
      {
        bill_to: requiredText("Bill To is required"),
        delivery_date: requiredText("Date is required"),
        address: requiredText("Address is required"),
        phone: requiredText("Phone number is required"),
        po_number: requiredText("PO number is required"),
       
        due_date: requiredText("Due date id is required"),
      },
    );

    const { itemsErrors: rowErrors, hasError: itemsHasError, generalError } = validateItems(
      items,
      {
        description: requiredText("Description is required"),
        qty: positiveNumber("Quantity must be greater than 0"),
        unit: requiredText("Unit is required"),
      }
    );

    setErrors(fieldErrors);
    setItemsErrors(rowErrors);
    setItemsGeneralError(generalError);

    const hasAnyError = Object.keys(fieldErrors).length > 0 || itemsHasError;

    if (hasAnyError) {
      focusFirstError({
        fieldErrors,
        itemsHasError,
        itemsSectionId: "delivery-order-items-section",
      });
    }

    return !hasAnyError;
  };

   console.log(quotationId);

  const handleSave = async () => {
    if (!validate()) return;

    try {
      setSubmitting(true);

      await createDeliveryOrder({
        po_number: poNumber,
        delivery_date: deliveryDate,
        due_date: dueDate,
        checked_by: checkedBy,
        approved_by: approvedBy,
        received_by: receivedBy,
        delivery_order_status_id: deliveryOrderStatusId,
        customer_id_ref: customerIdRef,
        items,
        sales_id: salesId,
      });
      

      await showSuccess("Delivery Order created successfully.");

      if (quotationId) { 
  await editStatusQuotation(Number(quotationId), {
    quotation_status_id: Number(7),
  });
      }
       
    
       
      navigate("/delivery_order");
    } catch (error) {
   
      showError("Failed to create delivery order.");
    } finally {
      setSubmitting(false);
    }
  };

  

  useEffect(() => {
    const loadStatus = async () => {
      try {
        const response = await getdeliveryOrderStatus();

        const statusList = response.data.deliveryOrderList ?? [];

        setStatusOptions(statusList);
      } catch (error) {
        showError("Failed", "Failed to load delivery Order Status.");
      }
    };

    loadStatus();
  }, []);

  // Kalau ada delivery_order_id di URL, prefill dari data invoice

  

  useEffect(() => {
    if (!quotationId) return;

    const fetchQuotation = async () => {
      try {
        setLoading(true);

        const response = await getQuotationById(Number(quotationId));
        const data = response.data.data ?? response.data;

        setDueDate(data.due_date);
        setBillTo(data.customer.company_name);
        setPhone(data.customer.phone);
        setAddress(data.customer.address);
        setPoNumber(data.po_number);

        setSalesId(data.sales?.id ?? 0);
        setItems(
          (data.items ?? []).map((item: any) => ({
            description: item.description,
            qty: Number(item.qty),
            unit: item.unit,
            remark: "",
            product_id: item.product_id ?? null,
          })),
        );

        if (data.customer) {
          setCustomerIdRef(data.customer.id);
          setCustomerQuery(
            data.customer.company_name
              ? `${data.customer.customer_name} (${data.customer.company_name})`
              : data.customer.customer_name,
          );
        }
      } catch (error) {
        console.error("Failed to load Delivery Order data:", error);
        showError("Failed to load Delivery Order data.");
      }
    };

    fetchQuotation();
  }, [delivery_order_id]);

  const deliveryOrderFields: DocumentFieldConfig<DeliveryOrderFormValue>[] = [
    { key: "bill_to", label: "Bill To", type: "readonly", column: 1 },
    { key: "address", label: "Address", type: "readonly", column: 1 },
    { key: "phone", label: "Phone", type: "readonly", column: 1 },
    {
      key: "delivery_order_no",
      label: "No Delivery Order",
      type: "readonly",
      column: 1,
    },
    { key: "delivery_date", label: "Date", type: "date", column: 1 },
    {
      key: "sales_id",
      label: "Sales",
      type: "select",
      column: 2,
      numeric: true,
      placeholderOption: { value: "", label: "Select Sales" },
      options: salesOptions.map((sales) => ({
        value: sales.id,
        label: sales.name,
      })),
    },
    { key: "po_number", label: "PO Number", type: "text", column: 2 },

    { key: "due_date", label: "Due Date", type: "date", column: 2 },
  ];

  const handleFieldChange = <K extends keyof DeliveryOrderFormValue>(
    key: K,
    value: DeliveryOrderFormValue[K]
  ) => {
    switch (key) {
      case "bill_to":
        setBillTo(value as string);
        break;
      case "address":
        setAddress(value as string);
        break;
      case "phone":
        setPhone(value as string);
        break;
      case "sales_id":
        setSalesId(value as number);
        break;
      case "delivery_date":
        setDeliveryDate(value as string);
        break;
      case "po_number":
        setPoNumber(value as string);
        break;

      case "due_date":
        setDueDate(value as string);
        break;
    }
  };

  return (
    <AdminLayout>
      <div className="rounded-3xl bg-white p-6">
        <div className="mb-6 flex items-center justify-between">
          <h2 className="text-lg font-semibold">Add Delivery Order</h2>
          <div>
            <label className="mr-3 text-sm text-gray-600">Status</label>
            <StatusDropdown
              options={statusOptions}
              value={deliveryOrderStatusId}
              onChange={setDeliveryOrderStatusId}
            />
          </div>
        </div>

        <CustomerPicker
          query={customerQuery}
          onQueryChange={setCustomerQuery}
          onSelectCustomer={handleSelectCustomer}
          selectedCustomerId={customerIdRef}
          onClearSelection={handleClearCustomer}
        />

        <DocumentInformation
          value={{
            bill_to: billTo,
            address,
            phone,
            sales_id: Number(salesId),
            delivery_date: deliveryDate,
            po_number: poNumber,

            due_date: dueDate,
          }}
          fields={deliveryOrderFields}
          labelWidthClass="w-40"
          errors={errors}
          onChange={withErrorClear(handleFieldChange, setErrors)}
        />

        <div className="my-6 border-t border-gray-100" />

        <div id="delivery-order-items-section">
          <h3 className="mb-3 text-sm font-semibold text-gray-700">
            Delivery Order Item
          </h3>
          <DeliveryOrderItemTable items={items} onChange={setItems} />
          {itemsGeneralError && (
            <p className="mt-2 text-xs text-red-500">{itemsGeneralError}</p>
          )}
          {Object.keys(itemsErrors).length > 0 && (
            <div className="mt-2 space-y-1">
              {Object.entries(itemsErrors).map(([rowIndex, rowErrors]) => (
                <p key={rowIndex} className="text-xs text-red-500">
                  Row {Number(rowIndex) + 1}:{" "}
                  {Object.values(rowErrors).join(", ")}
                </p>
              ))}
            </div>
          )}
        </div>

        <div className="my-6 border-t border-gray-100" />

        <div className="grid grid-cols-3 gap-6">
          <div>
            <label className="mb-1 block text-sm text-gray-600">
              Checked By
            </label>
            <input
              type="text"
              value={checkedBy}
              onChange={(e) => setCheckedBy(e.target.value)}
              placeholder="Input text"
              className={inputClass}
            />
          </div>

          <div>
            <label className="mb-1 block text-sm text-gray-600">
              Approved By
            </label>
            <input
              type="text"
              value={approvedBy}
              onChange={(e) => setApprovedBy(e.target.value)}
              placeholder="Input text"
              className={inputClass}
            />
          </div>

          <div>
            <label className="mb-1 block text-sm text-gray-600">
              Received By
            </label>
            <input
              type="text"
              value={receivedBy}
              onChange={(e) => setReceivedBy(e.target.value)}
              placeholder="Input text"
              className={inputClass}
            />
          </div>
        </div>

        <div className="mt-8 flex justify-end gap-3">
          <button
            onClick={handleCancel}
            disabled={submitting}
            className="rounded-xl border border-red-200 px-5 py-2.5 font-medium text-red-500 hover:bg-red-50 disabled:opacity-50">
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={submitting}
            className="rounded-xl bg-blue-600 px-5 py-2.5 font-medium text-white hover:bg-blue-700 disabled:opacity-50">
            {submitting ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </AdminLayout>
  );
}
